import { useEffect, useState } from 'react';
import CharCount from '../../charCount/CharCount';
import NestedTags from '../../nestedTags/NestedTags';
import './customPrice.css';
import { toast } from 'react-toastify';
import { fetchVehicleDropdownData } from '../../packUploadSection/quickView/fetchTypes/fetchDropdonwData';

export default function CustomPrice({ priceCount, packData, cityDrop, handlePrice, setPackData }) {
    const [vehicle, setVehicle] = useState({ name: '', price: null, seats: null });
    const [typeSel, setTypeSel] = useState('trip');
    const [vehicleOptions, setVehicleOptions] = useState([]);

    useEffect(() => {
        fetchVehicleDropdownData(typeSel, 'VehicleList', setVehicleOptions);
    }, [typeSel]);

    useEffect(() => {
        setTypeSel((prev) => prev);
    }, []);

    const vehicleNames = vehicleOptions && vehicleOptions.length > 0 ? vehicleOptions.map((option) => option.text) : [];
    const handleVehicleChange = (e) => {
        const selectedName = e.target.value;
        const selectedVehicle = vehicleOptions.find((v) => v.text === selectedName);

        if (selectedVehicle) {
            setVehicle((prev) => ({
                ...prev,
                name: selectedVehicle.text,
                seats: selectedVehicle.seats
            }));
        }
    };

    function CustomDropdown({ label, name, options, value, req, setFormData, className }) {
        return (
            <div className='itineraryInputDiv'>
                <select
                    value={value}
                    name={name}
                    onChange={(e) => handleVehicleChange(e)}
                    required={req}
                    className='nestedTagInput'
                >
                    <option value='-1'>Select</option>
                    {options?.map(function (val, typeIndex) {
                        return (
                            <option key={typeIndex} value={val}>
                                {val}
                            </option>
                        );
                    })}
                </select>
            </div>
        );
    }

    function addVehicle(index) {
        if (vehicle.name === '') {
            toast.error('Please enter the vehicle name');
        } else if (vehicle.price === 0) {
            toast.error('Please enter the vehicle price');
        }
        //  else if (!mapUrlPattern.test(pickup.location)) {
        //     alert('Enter proper map location URL');
        // }
        else {
            setPackData(function (prevState) {
                const updatedArrya = prevState.price.map(function (item, itemKey) {
                    if (index === itemKey) {
                        return {
                            ...item,
                            customPrice: {
                                ...item.customPrice,
                                vehicle: [...(item.customPrice?.vehicle || []), vehicle]
                            }
                        };
                    }
                    return item;
                });
                return { ...prevState, price: [...updatedArrya] };
            });
            setVehicle({ name: '', price: 0 });
        }
    }

    function removeVehicle(vehicleToRemove, index) {
        setPackData((prevState) => {
            const updatedArray = prevState.price.map((item, itemKey) => {
                if (index === itemKey) {
                    const currentVehicles = item.customPrice?.vehicle || [];

                    const filteredVehicles = currentVehicles.filter(
                        (v) => v.name !== vehicleToRemove.name || v.price !== vehicleToRemove.price
                    );

                    return {
                        ...item,
                        customPrice: {
                            ...item.customPrice,
                            vehicle: filteredVehicles
                        }
                    };
                }

                return item;
            });

            return {
                ...prevState,
                price: updatedArray
            };
        });
    }

    return (
        <>
            {Array.apply(null, { length: priceCount }).map(function (_, itnKey) {
                return (
                    <div key={itnKey}>
                        <p className='itineraryLabel'>City {itnKey + 1}</p>
                        <div className='itineraryInDiv'>
                            <label className='itineraryLabel'>Room Price</label>
                            <div className='itineraryInputDiv'>
                                <input
                                    value={packData.price[itnKey]?.customPrice?.room || null}
                                    type='number'
                                    name='room'
                                    onChange={(e) => handlePrice(e, itnKey)}
                                    placeholder={`Room Price for city ${itnKey + 1} `}
                                    className='itineraryInput'
                                ></input>
                                <CharCount
                                    string={
                                        packData.price[itnKey] ? String(packData.price[itnKey]?.customPrice?.room) : ''
                                    }
                                    min={2}
                                    limit={7}
                                />
                            </div>
                        </div>
                        <div className='itineraryInDiv'>
                            <label className='itineraryLabel'>Bed Price</label>
                            <div className='itineraryInputDiv'>
                                <input
                                    value={packData.price[itnKey]?.customPrice?.bed || null}
                                    type='number'
                                    name='bed'
                                    onChange={(e) => handlePrice(e, itnKey)}
                                    placeholder={`Bed Price for city ${itnKey + 1} `}
                                    className='itineraryInput'
                                ></input>
                                <CharCount
                                    string={
                                        packData.price[itnKey] ? String(packData.price[itnKey]?.customPrice?.bed) : ''
                                    }
                                    min={2}
                                    limit={7}
                                />
                            </div>
                        </div>
                        <div className='itineraryInDiv'>
                            <label className='itineraryLabel'>Per Person</label>
                            <div className='itineraryInputDiv'>
                                <input
                                    value={packData.price[itnKey]?.customPrice?.perPerson || null}
                                    type='number'
                                    name='perPerson'
                                    onChange={(e) => handlePrice(e, itnKey)}
                                    placeholder={`Per person price for city ${itnKey + 1} `}
                                    className='itineraryInput'
                                ></input>
                                <CharCount
                                    string={String(packData.price[itnKey]?.customPrice?.perPerson) ?? ''}
                                    min={2}
                                    limit={7}
                                />
                            </div>
                        </div>
                        <div className='itineraryInDiv'>
                            <label className='itineraryLabel'>Reserve</label>
                            <div className='itineraryInputDiv'>
                                <input
                                    value={packData.price[itnKey]?.customPrice?.reserve || null}
                                    type='number'
                                    name='reserve'
                                    onChange={(e) => handlePrice(e, itnKey)}
                                    placeholder={`Reserve price `}
                                    className='itineraryInput'
                                ></input>
                                <CharCount
                                    string={
                                        packData.price[itnKey]
                                            ? String(packData.price[itnKey]?.customPrice?.reserve)
                                            : ''
                                    }
                                    min={2}
                                    limit={7}
                                />
                            </div>
                        </div>
                        <>
                            <div className='itineraryInDiv custom'>
                                <label className='itineraryLabel'>Vehicle</label>
                                <div className='itineraryDiv1'>
                                    <CustomDropdown
                                        name={'name'}
                                        options={vehicleNames}
                                        value={vehicle.name}
                                        req={true}
                                        setFormData={setPackData}
                                    />
                                    {/* <input
                                        type='text'
                                        name='name'
                                        onChange={(e) =>
                                            setVehicle((prev) => ({
                                                ...prev,
                                                [e.target.name]: e.target.value
                                            }))
                                        }
                                        placeholder='Vehicle name'
                                        value={vehicle.name}
                                        className='nestedTagInput'
                                        // onKeyDown={(e) => {
                                        //     if (e.key === 'Enter') {
                                        //         addPickup();
                                        //     }
                                        // }}
                                    ></input> */}
                                    <div className='itineraryInputDiv'>
                                        <input
                                            type='number'
                                            name='price'
                                            onChange={(e) =>
                                                setVehicle((prev) => ({
                                                    ...prev,
                                                    [e.target.name]: e.target.value
                                                }))
                                            }
                                            placeholder='Vehicle Price'
                                            value={vehicle.price}
                                            className='nestedTagInput'
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    addVehicle(itnKey);
                                                }
                                            }}
                                        ></input>
                                        <button
                                            type='button'
                                            onClick={() => addVehicle(itnKey)}
                                            className='nestedTagOkBtn blueBtn'
                                        >
                                            Add Vehicle
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {packData?.price[itnKey]?.customPrice.vehicle?.length > 0 && (
                                <div className='tagContainer'>
                                    <div className='tagOutDiv'>
                                        {packData.price[itnKey].customPrice.vehicle.map((text, index) => {
                                            return (
                                                <div key={index} className='tagDiv'>
                                                    <p className='tagP'>{text.name}</p>
                                                    <button
                                                        className='tagButton'
                                                        onClick={(e) => removeVehicle(text, itnKey)}
                                                    >
                                                        X
                                                    </button>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}{' '}
                        </>
                        <div className='itineraryInDiv groupDiv'>
                            <label className='itineraryLabel'>Group Price</label>
                            <div className='itineraryInputDiv'>
                                <input
                                    value={packData.price[itnKey]?.customPrice?.groupPrice || null}
                                    type='number'
                                    name='groupPrice'
                                    onChange={(e) => handlePrice(e, itnKey)}
                                    placeholder={`Group Price for city ${itnKey + 1} `}
                                    className='itineraryInput'
                                ></input>
                                <CharCount
                                    string={
                                        packData.price[itnKey]
                                            ? String(packData.price[itnKey]?.customPrice?.groupPrice)
                                            : ''
                                    }
                                    min={2}
                                    limit={7}
                                />
                            </div>
                        </div>
                        <div className='itineraryInDiv startCityDiv'>
                            <label className='itineraryLabel'>Start City</label>
                            <div className='itineraryInputDiv'>
                                <select
                                    value={packData.price[itnKey] ? packData.price[itnKey].startCity : ''}
                                    name='startCity'
                                    onChange={(e) => handlePrice(e, itnKey)}
                                    className='citySelectPrice'
                                >
                                    <option value='-1'>Select</option>
                                    {cityDrop.map(function (val, typeIndex) {
                                        return (
                                            <option key={typeIndex} value={val.name}>
                                                {val.displayName}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                        <NestedTags packData={packData} setPackData={setPackData} index={itnKey} />
                        {/* {packData.price[itnKey]?.customPrice?.reserve <= 0 && (
                            <Installment
                                packData={packData}
                                setPackData={setPackData}
                                index={itnKey}
                                customPrice={true}
                            />
                        )} */}
                    </div>
                );
            })}
        </>
    );
}
